import { render, staticRenderFns } from "./SubCategoryManager.vue?vue&type=template&id=ffe56806&scoped=true"
import script from "./SubCategoryManager.vue?vue&type=script&lang=js"
export * from "./SubCategoryManager.vue?vue&type=script&lang=js"
import style0 from "./SubCategoryManager.vue?vue&type=style&index=0&id=ffe56806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe56806",
  null
  
)

export default component.exports